(function($) {

	$.fn.msxibutton = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxibutton.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            var options = {};

            if(eOpts['icon'] && eOpts['icon'].indexOf('msxi') > -1)
            {
                eOpts['icon'] += ' ui-icon-msxi';
            }
            if(eOpts['primary-icon'] && eOpts['primary-icon'].indexOf('msxi') > -1)
            {
                eOpts['primary-icon'] += ' ui-icon-msxi';
            }
            if(eOpts['secondary-icon'] && eOpts['secondary-icon'].indexOf('msxi') > -1)
            {
                eOpts['secondary-icon'] += ' ui-icon-msxi';
            }
            if(eOpts['icon'] || eOpts['primary-icon'] || eOpts['secondary-icon']) {
                options = $.extend( {}, options, {
                    text: !$this.hasClass("button-icon-only") && eOpts['icon-only'] != 'true' && eOpts['icon-only'] !== true,
                    icons: {
                        primary: eOpts['icon'] || eOpts['primary-icon'],
                        secondary: eOpts['secondary-icon']
                    }
                });
            }

            if($this.prop('disabled')) {
                $this.addClass('button-initial-disabled');
            }
            if($this.hasClass('button-initial-disabled')) {
                options['disabled'] = true;
            }

            $(this).button(options);
        });

	};
	//
	// plugin defaults
	//
	$.fn.msxibutton.defaults = {
		'icon-only': false,
        'icon': null,
        'secondary-icon': null
	};

})(jQuery);